<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="deliverymethod_no" [(ttModel)]="menu.deliverymethod_no" ttReadonly></tt-input>
        <tt-input ttLabel="deliverymethod_name" [(ttModel)]="menu.deliverymethod_name" ttReadonly></tt-input>
        <tt-input ttLabel="transcarrier_name" [(ttModel)]="menu.transcarrier_name" ttReadonly></tt-input>
        <tt-input ttLabel="transcarrier_product_name" [(ttModel)]="menu.transcarrier_product_name" ttReadonly></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListServices"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="deliverymethod_no" tt-model="vm.model.menu.deliverymethod_no" tt-change="vm.model.menu.deliverymethod_no = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="deliverymethod_name" tt-model="vm.model.menu.deliverymethod_name" tt-change="vm.model.menu.deliverymethod_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="transcarrier_name" tt-model="vm.model.menu.transcarrier_name" tt-change="vm.model.menu.transcarrier_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="transcarrier_product_name" tt-model="vm.model.menu.transcarrier_product_name" tt-change="vm.model.menu.transcarrier_product_name = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListServices" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
